import style from "./blog.module.css";
// import Semana1 from "./Semana1";
// import Semana2 from "./Semana2";
// import Semana3 from "./Semana3";
// import Semana4 from "./Semana4";
// import Semana5 from "./Semana5";
// import Semana6 from "./Semana6";
// import Semana7 from "./Semana7";
// import Semana8 from "./Semana8";
// import Semana9 from "./Semana9";
// import Semana10 from "./Semana10";
// import Semana11 from "./Semana11";
// import Semana12 from "./Semana12";
// import Semana13 from "./Semana13";
// import Semana14 from "./Semana14";
// import Semana15 from "./Semana15";
// import Semana16 from "./Semana16";
// import Semana17 from "./Semana17";
// import Semana18 from "./Semana18";
// import Semana19 from "./Semana19";
// import Semana20 from "./Semana20";
// import Semana21 from "./Semana21";
// import Semana22 from "./Semana22";
// import Semana23 from "./Semana23";
// import Semana24 from "./Semana24";
// import Semana25 from "./Semana25";
// import Semana26 from "./Semana26";
// import Semana27 from "./Semana27";
// import Semana28 from "./Semana28";
// import Semana29 from "./Semana29";
// import Semana30 from "./Semana30";
// import Semana31 from "./Semana31";
// import Semana32 from "./Semana32";
// import Semana33 from "./Semana33";
// import Semana34 from "./Semana34";
// import Semana35 from "./Semana35";
// import Semana36 from "./Semana36";
// import Semana37 from "./Semana37";
// import Semana38 from "./Semana38";
// import Semana39 from "./Semana39";
// import Semana40 from "./Semana40";
// import Semana41 from "./Semana41";
// import Semana42 from "./Semana42";
// import Semana43 from "./Semana43";
// import Semana44 from "./Semana44";
// import Semana45 from "./Semana45";
// import Semana46 from "./Semana47";
// import Semana47 from "./Semana46";
// import Semana48 from "./Semana48";
// import Semana49 from "./Semana49";
// import Semana50 from "./Semana50";
// import Semana51 from "./Semana51";
// import Semana52 from "./Semana52";
// import Semana53 from "./Semana53";
// import Semana54 from "./Semana54";
// import Semana55 from "./Semana55";
// import Semana56 from "./Semana56";
// import Semana57 from "./Semana57";
// import Semana58 from "./Semana58";
// import Semana59 from "./Semana59";
// import Semana60 from "./Semana60";
import Semana61 from "./Semana61";
import Semana62 from "./Semana62";
import Semana63 from "./Semana63";
import Semana64 from "./Semana64";
import Semana65 from "./Semana65";
import Semana66 from "./Semana66";
import Semana67 from "./Semana67";
import Semana68 from "./Semana68";
import Semana69 from "./Semana69";
import Semana70 from "./Semana70";

const Blog: React.FC = () => {
  //https://www.instagram.com/p/C25b0ygATVB/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==
  return (
    <main className={style.MasterBoxBlog}>
      <Semana70 />
      <Semana69 />
      <Semana68 />
      <Semana67 />
      <Semana66 />
      <Semana65 />
      <Semana64 />
      <Semana63 />
      <Semana62 />
      <Semana61 />
      {/* <Semana60 />
      <Semana59 />
      <Semana58 />
      <Semana57 />      
      <Semana56 />
      <Semana55 />
      <Semana54 />      
      <Semana53 />
      <Semana52 />      
      <Semana51 />
      <Semana50 /> */}
      {/* <Semana49 />
      <Semana48 />
      <Semana47 />
      <Semana46 />
      <Semana45 />
      <Semana44 />
      <Semana43 />
      <Semana42 />
      <Semana41 />
      <Semana40 />
      <Semana39 />
      <Semana38 />
      <Semana37 />
      <Semana36 />
      <Semana35 />
      <Semana34 />
      <Semana33 />
      <Semana32 />
      <Semana31 />
      <Semana30 />
      <Semana29 />
      <Semana28 />
      <Semana27 />
      <Semana26 />
      <Semana25 />
      <Semana24 />
      <Semana23 />
      <Semana22 />
      <Semana21 />
      <Semana20 />
      <Semana19 />
      <Semana18 />
      <Semana17 />
      <Semana16 />
      <Semana15 />
      <Semana14 />
      <Semana13 />
      <Semana12 />
      <Semana11 />
      <Semana10 />
      <Semana9 />
      <Semana8 />
      <Semana7 />
      <Semana6 />
      <Semana5 />
      <Semana4 />
      <Semana3 />
      <Semana2 />
      <Semana1 /> */}
    </main>
  );
};

export default Blog;
